import {
  Status,
  ProgressTrackerGroup,
  ProgressTrackerStages,
  ProgressTrackerStatus,
} from 'models/account';

export type findByProps = {
  group: string;
  stage: string;
};

export const getLatestStatus = (data: Status[] | undefined) => {
  if (!data) {
    return null;
  }
  if (data.length === 0) {
    return null;
  }
  // take last status from array which always new
  return data[data.length - 1];
};

export const findByGroupAndStage = (
  data: ProgressTrackerGroup[],
  props: findByProps,
) =>
  data.find((item) => item.group === props.group && item.stage === props.stage);

export const isStageComplete = (
  stage: ProgressTrackerStages,
  data: ProgressTrackerGroup[],
): boolean => {
  const currentStage = data?.find((item) => item.stage === stage);
  const latestStatus = getLatestStatus(currentStage?.status);
  return latestStatus?.status === ProgressTrackerStatus.Completed;
};

export const isStageStatus = (
  stage: ProgressTrackerStages,
  data: ProgressTrackerGroup[],
  status: ProgressTrackerStatus,
): boolean => {
  const currentStage = data?.find((item) => item.stage === stage);
  const latestStatus = getLatestStatus(currentStage?.status);
  return latestStatus?.status === status;
};

export const formatEIN = (ein: string): string => {
  // only process if ein is 9 digit
  if (/^\d{9}$/.test(ein)) {
    return `${ein.substring(0, 2)}-${ein.substring(2)}`;
  }
  return ein;
};
